import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function PackingMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Quản lý Đóng gói & Giao Hàng
        </span>
        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-[10px] md:text-xs font-medium">
          Lịch Xe Ngày 26/05
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col gap-4 overflow-auto">
        <div className="grid grid-cols-2 gap-4">
          {/* Chuyến 1 */}
          <div className="border border-slate-200 rounded-lg p-3 shadow-sm relative">
            <div className="absolute top-3 right-3 text-[10px] font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-100">
              Đang Xếp Hàng
            </div>
            <div className="flex items-center gap-2 mb-2">
              <div className="text-xl">🚚</div>
              <div>
                <div className="font-bold text-slate-800 text-xs">
                  Xe Tải 2.5 Tấn (51C-123.45)
                </div>
                <div className="text-[10px] text-slate-500">
                  Tài xế: Lê Văn B - 09:00 AM
                </div>
              </div>
            </div>
            <div className="bg-slate-50 p-2 rounded border border-slate-100 text-[10px]">
              <div className="font-bold text-slate-700 mb-1">
                Khách hàng: Cty Dược Phẩm X
              </div>
              <div className="flex justify-between text-slate-600">
                <span>PO-120: Hộp Yến</span>
                <span>
                  <span className="font-bold text-slate-800">45/50</span> Thùng
                </span>
              </div>
              <div className="w-full h-1 bg-slate-200 rounded-full mt-1 overflow-hidden">
                <div className="h-full bg-emerald-500 w-[90%]"></div>
              </div>
            </div>
          </div>

          {/* Chuyến 2 */}
          <div className="border border-slate-200 rounded-lg p-3 shadow-sm opacity-60">
            <div className="absolute top-3 right-3 text-[10px] font-bold text-slate-500 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">
              Chờ Lấy
            </div>
            <div className="flex items-center gap-2 mb-2">
              <div className="text-xl">🛵</div>
              <div>
                <div className="font-bold text-slate-800 text-xs">
                  Giao hàng nhanh (Ahamove)
                </div>
                <div className="text-[10px] text-slate-500">
                  Tài xế: --- - 14:00 PM
                </div>
              </div>
            </div>
            <div className="bg-slate-50 p-2 rounded border border-slate-100 text-[10px]">
              <div className="font-bold text-slate-700 mb-1">
                Khách hàng: Shop Mỹ Phẩm Y
              </div>
              <div className="flex justify-between text-slate-600">
                <span>PO-089: Hộp Mỹ Phẩm</span>
                <span>
                  <span className="font-bold text-slate-800">0/5</span> Thùng
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm flex-1 flex flex-col">
          <div className="bg-slate-50 border-b border-slate-200 p-2 text-xs font-bold text-slate-700">
            Chi tiết quét mã vạch lên xe (51C-123.45)
          </div>
          <div className="flex-1 p-2 bg-slate-100/50 text-[10px] font-mono text-slate-600 space-y-1 overflow-y-auto">
            <div className="flex gap-2">
              <span className="text-emerald-600">✓ 09:15:22</span>{" "}
              <span>Thùng #43 - LOT: PO120-043 (1,000 hộp)</span>
            </div>
            <div className="flex gap-2">
              <span className="text-emerald-600">✓ 09:15:45</span>{" "}
              <span>Thùng #44 - LOT: PO120-044 (1,000 hộp)</span>
            </div>
            <div className="flex gap-2">
              <span className="text-emerald-600">✓ 09:16:10</span>{" "}
              <span>Thùng #45 - LOT: PO120-045 (1,000 hộp)</span>
            </div>
            <div className="flex gap-2 animate-pulse">
              <span className="text-indigo-500">
                ⌛ Đang chờ quét thùng tiếp theo...
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-900 text-slate-200">
      <div className="p-3 border-b border-slate-800 flex items-center justify-between z-10 sticky top-0 shadow-md bg-slate-900">
        <span className="text-xs font-semibold text-white">
          Scanner Đóng Gói
        </span>
        <span className="text-[10px] bg-slate-800 px-2 py-1 rounded text-slate-400">
          PO-120
        </span>
      </div>

      <div className="flex-1 p-4 flex flex-col relative justify-center items-center">
        {/* Camera Viewfinder */}
        <div className="w-48 h-48 border-2 border-indigo-500/50 rounded-2xl relative mb-8">
          {/* Corner accents */}
          <div className="absolute top-[-2px] left-[-2px] w-4 h-4 border-t-2 border-l-2 border-indigo-500 rounded-tl-xl"></div>
          <div className="absolute top-[-2px] right-[-2px] w-4 h-4 border-t-2 border-r-2 border-indigo-500 rounded-tr-xl"></div>
          <div className="absolute bottom-[-2px] left-[-2px] w-4 h-4 border-b-2 border-l-2 border-indigo-500 rounded-bl-xl"></div>
          <div className="absolute bottom-[-2px] right-[-2px] w-4 h-4 border-b-2 border-r-2 border-indigo-500 rounded-br-xl"></div>

          {/* Laser line */}
          <div className="absolute top-1/2 left-4 right-4 h-[1px] bg-red-500 shadow-[0_0_8px_#ef4444]"></div>
        </div>

        <div className="bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-xl text-center w-full max-w-[200px]">
          <div className="text-[10px] text-slate-400 mb-1">
            Đã quét & Xếp xe
          </div>
          <div className="text-3xl font-bold text-white mb-1">
            45<span className="text-sm text-slate-500 font-normal">/50</span>
          </div>
          <div className="text-[9px] text-emerald-400 font-bold uppercase tracking-widest">
            Thùng
          </div>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
